<template src="./NewSchedule.html" />

<script>
import { useStore } from "@/store/store.js"
import moment from "moment";
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  components: { WholeMultiselect },
  mixins: [mixins],
  props: {
    patient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      doctorsCount: 0,
      priceMin: 0,
      priceMax: 0,
      showPriceRange: false,
      disabledConfirmButton: true,
      attendanceTypeVideo: true,
      attendanceTypePresential: false,
      popupScheduleAppointment: false,
      specialties: [],
      period: "integral",
      showButtonAddress: true,
      showFieldsAddress: false,
      male: false,
      female: false,
      indifferent: false,
      specialtySelected: [],
      isProject: false,
    };
  },
  watch: {
    male: function (newVal) {
      let vm = this;
      if (newVal) {
        vm.female = false;
        vm.indifferent = false;
        vm.postCount();
      }
    },
    attendanceTypePresential: function (newVal) {
      this.attendanceTypeVideo = !newVal;
      if (this.attendanceTypeVideo)
        this.postCount();
    },
    attendanceTypeVideo: function (newVal) {
      this.attendanceTypePresential = !newVal;
      if (this.attendanceTypePresential)
        this.postCount();
    },
    female: function (newVal) {
      let vm = this;
      if (newVal == true) {
        vm.male = false;
        vm.indifferent = false;
        vm.postCount();
      }
    },
    indifferent: function (newVal) {
      let vm = this;
      if (newVal == true) {
        vm.male = false;
        vm.female = false;
        vm.postCount();
      }
    },
    doctorsCount: function (newVal) {
      let vm = this;
      if (vm.specialtySelected.id && newVal > 0) {
        vm.disabledConfirmButton = false;
      } else {
        vm.disabledConfirmButton = true;
      }
    },
    specialtySelected: function () {
      let vm = this;
      vm.getPriceRange();
      if (vm.specialtySelected.id) {
        vm.postCount();
      }
    },
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted: function () {
    let vm = this;
    vm.init();
  },
  methods: {
    init() {
      let vm = this;
      vm.isProject = vm.$session.get("isProject") ? vm.$session.get("isProject") : false;
      vm.getSpecialties();
    },

    getPriceRange() {
      let vm = this;
      if (vm.specialtySelected.id)
        vm.axios
          .get(
            vm.$store.state.filooServer +
              "specialties/" +
              vm.specialtySelected.id +
              "/price-range",
            {
              headers: { Authorization: vm.$session.get("bearer") },
            }
          )
          .then(function (response) {
            if (response.status === 200) {
              vm.priceMax = response.data.max;
              vm.priceMin = response.data.min;
              vm.showPriceRange = true;
            }
          });
    },
    clickShowFieldsAddress() {
      let vm = this;
      vm.showButtonAddress = false;
      vm.showFieldsAddress = true;
    },
    clickCancelChangeAddress() {
      let vm = this;
      vm.showButtonAddress = true;
      vm.showFieldsAddress = false;
    },
    handleResize() {
      let vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 1100) {
        vm.showWebTable = false;
        if (vm.window.width < 420) {
          vm.showButtonSmallScreen = true;
        } else {
          vm.showButtonSmallScreen = false;
        }
      } else {
        vm.showWebTable = true;
      }
    },
    goToHistoric(idPatient) {
      let vm = this;
      vm.idPatient = idPatient;
      vm.listPatients = false;
    },
    schedulePatient(patient) {
      let vm = this;
      vm.patient = patient;
      if (vm.patient.address === null) {
        vm.patient.address = {
          street: "",
          number: "",
          city: "",
          state: "",
          complement: "",
          zipcode: "",
          neighborhood: "",
        };
      }
      (vm.showButtonAddress = true),
        (vm.showFieldsAddress = false),
        (vm.male = false),
        (vm.female = false),
        (vm.indifferent = false),
        (vm.specialtySelected = []),
        (vm.doctorsCount = 0),
        (vm.priceMin = 0),
        (vm.priceMax = 0),
        (vm.showPriceRange = false),
        vm.postCount();
      vm.period = "integral";
      vm.popupScheduleAppointment = true;
      vm.disabledConfirmButton = true;
    },
    postCount() {
      let vm = this;
      if (vm.testNullUndefinedEmpty(vm.patient.address)) {
        return;
      }
      let dateNow = moment().format("DD/MM/YYYY");
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      let customerPlan = vm.testNullUndefinedEmpty(vm.$session.hasOwnProperty("customerPlan")) ? vm.$session.get("customerPlan") : null;
      let data = {
        address: vm.patient.address,
        price: 0,
        attendanceType: null,
        dates: [
          {
            date: dateNow,
            initial: "08:00",
            end: "22:00",
          },
        ],
        distance: 21000,
      };
      if (vm.attendanceTypePresential === true) {
        data.attendanceType = 1;
      }
      if (vm.attendanceTypeVideo === true) {
        data.attendanceType = 2;
      }
      if (vm.specialtySelected.id) {
        data.specialty = vm.specialtySelected;
      }
      if (vm.male == true) {
        data.gender = "MALE";
      }
      if (vm.female == true) {
        data.gender = "FEMALE";
      }
      if (vm.indifferent == true) {
        data.gender = "UNDEFINED";
      }
      if (customerPlan !== null && customerPlan !== undefined) {
        data.customerPlanId = customerPlan.id;
      }
      vm.axios
        .post(vm.$store.state.filooServer + "schedules/count", data)
        .then(function (response) {
          if (response.status === 201) {
            vm.doctorsCount = response.data.value;
            if (vm.showFieldsAddress == true) {
              vm.showFieldsAddress = false;
              vm.showButtonAddress = true;
            }
          }
        });
    },
    postSchedule() {
      let vm = this;
      let dateNow = moment().add(2, "days").format("DD/MM/YYYY");
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      let data = {
        address: vm.patient.address,
        price: 0,
        distance: 21000,
        dates: [
          {
            date: dateNow,
            initial: "06:00",
            end: "21:00",
          },
        ],
      };

      if (vm.period == "morning") {
        data = {
          address: vm.patient.address,
          price: 0,
          distance: 21000,
          dates: [
            {
              date: dateNow,
              periodo: "manha",
              initial: "06:00",
              end: "12:00",
            },
          ],
        };
      } else if (vm.period == "afternoon") {
        data = {
          address: vm.patient.address,
          price: 0,
          distance: 21000,
          dates: [
            {
              date: dateNow,
              periodo: "tarde",
              initial: "12:00",
              end: "21:00",
            },
          ],
        };
      } else if (vm.period == "integral") {
        data = {
          address: vm.patient.address,
          price: 0,
          distance: 21000,
          dates: [
            {
              date: dateNow,
              initial: "06:00",
              end: "21:00",
            },
          ],
        };
      }

      if (vm.attendanceTypePresential) {
        data.attendanceType = 1;
      }
      if (vm.attendanceTypeVideo) {
        data.attendanceType = 2;
      }
      if (vm.specialtySelected.id) {
        data.specialty = vm.specialtySelected;
      }
      if (vm.male) {
        data.gender = "MALE";
      }
      if (vm.female) {
        data.gender = "FEMALE";
      }
      if (vm.indifferent) {
        data.gender = "UNDEFINED";
      }

      vm.axios
        .post(
          vm.$store.state.filooServer + "schedules/cria/" + vm.patient.id,
          data
        )
        .then(function (response) {
          if (response.status === 201) {
            vm.popupScheduleAppointment = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Operação realizada com sucesso!",
              icon: "success",
            }).then(() => {
              vm.goBack();
            });
          }
        })
        .catch(function () {
          vm.popupScheduleAppointment = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error",
          });
        });
    },
    getSpecialties() {
      let vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(vm.$store.state.filooServer + "specialties")
        .then(function (response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        });
    },
    async getAdressData() {
      const response = await this.getAddressByZipcode(this.patient.address.zipcode)

      if (response && response.address) {
        this.patient.address = response.address
      }
    },

    goBack() {
      this.$emit('close');
    }
  },
};
</script>
<style lang="scss" src="./NewSchedule.scss">
</style>
